import React from 'react';
import Separator from '../../shared/components/Separator';
import { TRAFFIC_STATUS_OPTIONS, TrafficButtonsPreview } from '../../shared/components/TrafficButtons';

import { ReactComponent as UpIcon } from '../../assets/icons/upArrow.svg';
import { ReactComponent as DownIcon } from '../../assets/icons/downArrow.svg';

const getStatusAnswerSections = (answer = '') => {
  const paragraphs = [];
  const statusItems = [];

  answer
    .split('\n')
    .map((line) => line.trim())
    .filter(Boolean)
    .forEach((line) => {
      const match = line.match(/^([^:]+):\s*(.+)$/);
      const label = match?.[1]?.trim().toLowerCase();
      const description = match?.[2]?.trim();
      const statusOption = TRAFFIC_STATUS_OPTIONS.find(
        (option) => option.label.toLowerCase() === label
      );

      if (statusOption && description) {
        statusItems.push({
          ...statusOption,
          description,
        });
        return;
      }

      paragraphs.push(line);
    });

  return {
    paragraphs,
    statusItems,
  };
};

const Question = ({ question, answer }) => {
  const [answerVisible, setAnswerVisible] = React.useState(false);
  const toggleAnswer = () => setAnswerVisible((previous) => !previous);
  const { paragraphs, statusItems } = React.useMemo(
    () => getStatusAnswerSections(answer),
    [answer]
  );

  return (
    <div className="help-question">
      <button className="help-question__toggle"
              type="button"
              onClick={toggleAnswer}>
        <span className="help-question__title">{question}</span>
        {answerVisible ?
          <UpIcon className="icon base help-question__icon" />
         :
          <DownIcon className="icon base help-question__icon" /> }
      </button>
      {answerVisible && (
        <Separator className="help-question__separator" />
      )}

      <div className="answer help-question__answer">
        {answerVisible && (
          <>
            {paragraphs.map((p, i) => {
              return (
                <p key={i}
                   dangerouslySetInnerHTML={{__html: p}} />
              );
            })}

            {statusItems.length > 0 && (
              <div className="help-status-reference" aria-label="Verification status reference">
                {statusItems.map((status) => (
                  <div key={status.level} className="help-status-reference__item">
                    <TrafficButtonsPreview
                      level={status.level}
                      showLabel={false}
                      className="help-status-reference__control"
                    />
                    <div className="help-status-reference__copy">
                      <span className="help-status-reference__label">{status.label}</span>
                      <span className="help-status-reference__description">
                        {status.description}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default Question;
